// utils.js or loadingUtils.js

// Function to start loading (sets loading and disabled to true)
export const StartLoading = (setIsLoading) => {
    setIsLoading(true);  // Sets loading state to true
    // setIsDisabled(true); // Sets disabled state to true
};

// Function to stop loading (sets loading and disabled to false)
export const StopLoading = (setIsLoading) => {
    setIsLoading(false);  // Sets loading state to false
    // setIsDisabled(false); // Sets disabled state to false
};


